/** Sub-tabs of /management?tab=appsumo, in display order. */
export const APPSUMO_VIEWS = [
  { id: 'activity', label: 'Activity' },
  { id: 'licenses', label: 'Licenses' },
  { id: 'abuse', label: 'Abuse' },
] as const;

export type AppsumoView = (typeof APPSUMO_VIEWS)[number]['id'];

export const DEFAULT_APPSUMO_VIEW: AppsumoView = 'activity';

export const isAppsumoView = (value: unknown): value is AppsumoView =>
  APPSUMO_VIEWS.some((v) => v.id === value);

/** Tab ids the AppSumo views had before they merged into one section.
 *  Old bookmarks and shared links keep landing on the right view. */
export const LEGACY_APPSUMO_TABS: Record<string, AppsumoView> = {
  'appsumo-abuse': 'abuse',
};
